import * as R from 'ramda';
import Immutable from 'seamless-immutable';
import { i18n } from 'invision-core';
import { createSelector } from 'reselect';
import CustomerCareKeys from '../../locales/keys';
import { getNextStepIndex, getPreviousStepIndex } from './wizard.helper';
import { setFormattedName, setFormattedCityState } from './customer.helper';
var DEFAULT_TAB_PANEL_VIEW_MODEL = Immutable([{
  glyph: 'shopping-cart',
  notificationCount: 0
}, {
  glyph: 'user',
  notificationCount: 0
}
// {
//     glyph: 'file-text',
//     notificationCount: 0
// }
// Commenting out since we are going implement in the future
]);
export var BackButtonText = function BackButtonText(inputSelectors, allStepsKeys) {
  return createSelector(inputSelectors, function (currentStepIndex, completedSteps) {
    var previousStepIndex = getPreviousStepIndex(allStepsKeys, completedSteps, currentStepIndex);
    var previousStepKey = allStepsKeys[previousStepIndex];
    return previousStepKey ? i18n.translate(CustomerCareKeys.BACK_TO_STEP, {
      step: i18n.translate(previousStepKey)
    }) : '';
  });
};
export var ForwardButtonText = function ForwardButtonText(inputSelectors, allStepsKeys) {
  return createSelector(inputSelectors, function (currentStepIndex, skippedSteps) {
    var nextStepIndex = getNextStepIndex(allStepsKeys, skippedSteps, currentStepIndex);
    var nextStepKey = allStepsKeys[nextStepIndex];
    return nextStepKey ? i18n.translate(CustomerCareKeys.CONTINUE_TO_STEP, {
      step: i18n.translate(nextStepKey)
    }) : i18n.translate(CustomerCareKeys.COMPLETE_ORDER);
  });
};
export var TabPanelViewModel = function TabPanelViewModel(inputSelectors) {
  return createSelector(inputSelectors, function (selectedTabIndex) {
    return DEFAULT_TAB_PANEL_VIEW_MODEL.map(function (item, index) {
      return item.set('active', index === selectedTabIndex);
    });
  });
};
export var FormattedName = function FormattedName(inputSelectors) {
  return createSelector(inputSelectors, function (customerInfo) {
    return setFormattedName(customerInfo);
  });
};
export var FormattedCityState = function FormattedCityState(inputSelectors) {
  return createSelector(inputSelectors, function (customerInfo) {
    return setFormattedCityState(customerInfo);
  });
};
export var FormattedAddressCityState = function FormattedAddressCityState(inputSelectors) {
  return createSelector(inputSelectors, function (serviceAddress) {
    if (!serviceAddress) {
      return '';
    }
    if (!serviceAddress.State) {
      return serviceAddress.City;
    }
    if (serviceAddress.City === '' || !serviceAddress.City) {
      return serviceAddress.State;
    }
    return "".concat(serviceAddress.City, ", ").concat(serviceAddress.State);
  });
};
export var CurrentStepIndex = function CurrentStepIndex(inputSelectors) {
  return createSelector(inputSelectors, function (wizardStore) {
    return wizardStore.currentStepIndex;
  });
};
export var CompletedSteps = function CompletedSteps(inputSelectors) {
  return createSelector(inputSelectors, function (wizardStore) {
    return wizardStore.completedSteps;
  });
};
export var CurrentStep = function CurrentStep(inputSelectors, allStepsKeys) {
  return createSelector(inputSelectors, function (currentStepIndex) {
    return allStepsKeys[currentStepIndex];
  });
};
export var IsActiveStep = function IsActiveStep(inputSelectors, allStepsKeys, index) {
  return createSelector(inputSelectors, function (currentStep) {
    return currentStep === allStepsKeys[index];
  });
};
export var IsActiveTransitionStep = function IsActiveTransitionStep(inputSelectors, localeKey) {
  return createSelector(inputSelectors, function (currentStep) {
    return currentStep === localeKey;
  });
};
export var CurrentStepIsInvalid = function CurrentStepIsInvalid(inputSelectors) {
  return createSelector(inputSelectors, function (wizardStore) {
    return wizardStore.currentStepIsInvalid;
  });
};
export var SelectedTabIndex = function SelectedTabIndex(inputSelectors) {
  return createSelector(inputSelectors, function (wizardStore) {
    return wizardStore.selectedTabIndex;
  });
};
export var SkippedStep = function SkippedStep(inputSelectors) {
  return createSelector(inputSelectors, function (wizardStore) {
    return wizardStore.skippedSteps;
  });
};
export var StepProgressBarViewModel = function StepProgressBarViewModel(inputSelectors, allStepsKeys) {
  return createSelector(inputSelectors, function (currentStep, completedStepsMap, skippedSteps) {
    return allStepsKeys.map(function (step) {
      return {
        name: i18n.translate(step),
        active: currentStep === step,
        visited: !!completedStepsMap[step],
        skipped: R.includes(step, skippedSteps)
      };
    });
  });
};
export var getLastFourDigits = function getLastFourDigits(digitString) {
  var lastFourDigits = null;
  if (digitString && digitString.length) {
    if (digitString.length >= 4) {
      lastFourDigits = digitString.substring(digitString.length - 4);
    } else {
      lastFourDigits = digitString.substring(0, digitString.length);
    }
  }
  return lastFourDigits;
};